import React from "react";
import PropTypes from "prop-types";

const Cross = ({ className, color }) => {
  switch (color) {
    case `dark-green`:
      color = `#006855`;

      break;

    case `orange`:
    default:
      color = `#EF5518`;
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 29 22">
      <g
        id="Pop-up-Delivery-FYI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <g
          id="Desktop-Copy-2"
          transform="translate(-1212.000000, -38.000000)"
          stroke={color}
          strokeWidth="3"
        >
          <g id="Cross-2" transform="translate(1214.000000, 40.000000)">
            <g id="Cross">
              <path
                d="M1,17 L25,1"
                id="Line"
                transform="translate(13.000000, 9.000000) rotate(-1.309932) translate(-13.000000, -9.000000) "
              ></path>
              <path d="M1,1 L24.674906,17.4694998" id="Line"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Cross.defaultProps = {
  className: ``,
  color: `orange`
};

Cross.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Cross;
